import { fetchUserContractList } from '@/api';

const namespaced = true;

const state = {
	userContractList: [],
};

const getters = {
	userContractList(state) {
		return state.userContractList;
	},
};

const mutations = {
	setUserContractList(state, { page, list }) {
		page === 1
			? (state.userContractList = [...list])
			: (state.userContractList = [...state.userContractList, ...list]);
	},
	initUserContractList(state) {
		state.userContractList = [];
	},
};

const actions = {
	getUserContractList({ commit }, payload) {
		return fetchUserContractList(payload)
			.then(response => {
				if (response.data.code === '00000')
					commit('setUserContractList', response.data);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	initUserContractList({ commit }) {
		commit('initUserContractList');
	},
};

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions,
};
